import { Box, Theme, withStyles } from '@material-ui/core';
import { purple } from 'globals/colors';

export const TagListWrapper = withStyles(({ spacing }: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: spacing(2),
    backgroundColor: purple.V5,
    borderRadius: spacing(1),
  },
}))(Box);

export default {
  TagListWrapper,
};
